// Leadership sourced from the client's "GIA Longevity Leadership" slide
// (Website Review V2 — photos and titles "for now"). Bios to follow.

import type { ImageName } from '@/generated/images'

export interface Leader {
  id: string
  name: string
  role: string
  photo: ImageName
}

export const leadership: Leader[] = [
  {
    id: 'luis-gallegos',
    name: 'Ambassador Luis Gallegos',
    role: 'President',
    photo: 'team-luis-gallegos',
  },
  {
    id: 'silvia-candamil-neira',
    name: 'Silvia Candamil Neira',
    role: 'Vice President',
    photo: 'team-silvia-candamil-neira',
  },
  {
    id: 'kirsten-suto-seckler',
    name: 'Kirsten Suto Seckler',
    role: 'Founding Executive Director, U.S. Chapter',
    photo: 'team-kirsten-suto-seckler',
  },
  {
    id: 'alison-bryant',
    name: 'Alison Bryant',
    role: 'Inaugural Board Chair, U.S. Chapter · Chief Operating Officer, Learning Economy',
    photo: 'team-alison-bryant',
  },
  {
    id: 'david-evangelista',
    name: 'David Evangelista',
    role: 'Board Member, U.S. Chapter · CEO, Special Olympics',
    photo: 'team-david-evangelista',
  },
]
